const ITEM_ALIASES = {
  "centre table": "center table",
  "dinning table 4 seater": "dining table 4 seater",
  "dinning table 6 seater": "dining table 6 seater",
  "a c 1 ton": "ac 1 ton",
  "a c 1 5 ton": "ac 1 5 ton",
  "a/c 1 ton": "ac 1 ton",
  "a/c 1.5 ton": "ac 1 5 ton",
  "tv lcd plasma": "tv unit",
  "tv lcd / plasma": "tv unit",
  "mattress king size": "mattress king",
  "mattress queen size": "mattress queen",
  "mattress single size": "mattress single",
  "ups/inverter": "ups inverter",
  "book shelf": "books shelf",
  "vcr/vcd/dvd": "vcr vcd dvd",
  "cooker(5kg)": "cooker 5kg",
};

export default ITEM_ALIASES;
